import { inject, Injectable } from '@angular/core';
import { RestService } from '@tdwb/core';

@Injectable({ providedIn: 'root' })
export class IntegrationService {
  private readonly restService = inject(RestService);

  sendKeepAlive(): void {
    this.restService.getResource('session.keepalive').get().subscribe();
  }
}
